import React, {useMemo, useRef, useState} from 'react';
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import {OverlayPanel} from "primereact/overlaypanel";
import {ListBox} from "primereact/listbox";
import {InputText} from "primereact/inputtext";
import TaskTypeDialog from "../../components/task-type-dialog";

function SelectTaskType({selectedTaskType, taskTypes=[], onChange}) {
    const [visible, setVisible] = useState(false);
    const overlayRef = useRef(null);
    const translate = useTranslate();

    const safeTaskTypes = useMemo(
        () => Array.isArray(taskTypes) ? taskTypes : [],
        [taskTypes]
    );

    const options = useMemo(() => [
        {label: translate("select-task-type"), value: -1, icon: "assignment"},
        ...safeTaskTypes.map(taskType => ({
            label: taskType.title,
            value: taskType.id,
            data: taskType,
            icon: taskType.icon
        })),
        {label: `${translate("create-task-type")}...`, value: -2, icon: "add"}
    ], [safeTaskTypes, translate]);

    function ItemTemplate(option) {
        return(
            <div className="flex align-items-center gap-2 p-2 cursor-pointer">
                <Icon icon={`mi mi:${option?.icon || "assignment"}`} className="text-lg"/>
                <span className="text-xs">{option?.label}</span>
            </div>
        )
    }

    const selectedOption = selectedTaskType
        ? {
            label: selectedTaskType.title,
            data: selectedTaskType,
            icon: selectedTaskType.icon
        }
        : options[0];

    return(
        <>
            <div
                className="flex align-items-center cursor-pointer"
                onClick={(event) => overlayRef.current?.toggle(event)}
            >
                <ItemTemplate {...selectedOption}/>
                <Icon icon="mi mi:keyboard_arrow_down" className="text-lg"/>
            </div>

            <OverlayPanel
                ref={overlayRef}
                pt={{
                    root: () => ({className: "p-0 rtl w-15rem project-overlay z-dropdown-panel"}),
                    content: () => ({className: "p-0"})
                }}
            >
                <ListBox
                    className="w-15rem border-none"
                    filter
                    filterBy="label"
                    options={options}
                    value={selectedTaskType?.id ?? -1}
                    optionLabel="label"
                    optionValue="value"
                    itemTemplate={ItemTemplate}
                    pt={{
                        item: () => ({className: "p-0"}),
                        header: () => ({className: "p-1 border-none shadow-none"})
                    }}
                    filterTemplate={(filterOptions) => (
                        <div className="p-2">
                            <InputText
                                className="p-2 w-full text-xs"
                                placeholder={translate("search")}
                                onChange={filterOptions.filterOptions.filter}
                            />
                        </div>
                    )}
                    onChange={(event) => {
                        overlayRef.current?.hide();

                        if (event.value === -2) {
                            setVisible(true);
                            return;
                        }

                        onChange?.(
                            safeTaskTypes.find(taskType => taskType.id === event.value) ?? null
                        );
                    }}
                />
            </OverlayPanel>
            <TaskTypeDialog visible={visible} setVisible={setVisible} taskTypeData={selectedTaskType} onSubmit={(e)=>{onChange(e);}}/>
        </>
    )
}

export default SelectTaskType;
